import ActionRender from './ActionRender';

export const getActions = (actionList = [], renderActionsDirectly = false) => {
  const filteredActionList = actionList?.filter((action) => action?.permitted) ?? [];

  if (filteredActionList?.length) {
    return {
      name: 'Actions',
      style: {
        border: 'none !important',
      },
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      cell: (row) => (
        <ActionRender filteredActionList={filteredActionList} row={row} renderActionsDirectly={renderActionsDirectly} />
      ),
    };
  }
  return null;
};
